import React, { useState } from 'react';
import uuid from 'uuid-random';
import { RouteComponentProps, useLocation, useParams } from '@reach/router';
import { LessonsHeaderContainer } from '../LessonsHeader';
import { useEffect } from 'react';
import { lessonsApi } from '../../API/lessons';
import { lessonsNavLinks } from '../../pages/Lessons/config';
import { BookLabelName } from '../../types/exemplars';
import { FlexBehavior, FlexJustify, Spinner } from 'react-magma-dom';
import { ContactUsError } from '../ContactUsError';
import {
  ExemplarsContainer,
  LessonsContainer,
  LessonsSubHeader,
  StyledCenteredSpinnerWrapper,
} from '../Styled/StyledWrappers';
import { StyledColoredLine } from '../Styled';
import { ExemplarDataLesson } from '../../types';
import { getTopLineBgColor } from '../../utils';
import { COLORS } from '../../constants';
import { ComingSoon } from '../ComingSoon';
import { getLessonAvailability } from '../../utils/envs';
import { Related } from '../RelatedElement';

export const LessonTextType: React.FC<RouteComponentProps> = () => {
  const { pathname } = useLocation();
  const params = useParams();

  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isComingSoon, setIsComingSoon] = useState(false);
  const [exemplars, setExemplars] = useState<ExemplarDataLesson[]>([]);
  const [backLinkNames, setBackLinkName] = useState<string[]>([]);
  const [title, setTitle] = useState<BookLabelName>(BookLabelName.default);

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { data },
        } = await lessonsApi.getExemplars(params.exemplarId);

        const firstCollectionName = data[0].collectionName;
        setIsComingSoon(!getLessonAvailability(firstCollectionName.split(/(\s+)/)[0]));
        setExemplars(data);
        setTitle(firstCollectionName);
        setBackLinkName(['Find a lesson plans', firstCollectionName, data[0].textTypeName]);
      } catch (error) {
        setError(!!error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const [linear1, linear2, linear3] = title ? getTopLineBgColor(title) : [];

  if (isComingSoon) {
    return <ComingSoon stageNotReady />;
  }

  if (isLoading) {
    return (
      <StyledCenteredSpinnerWrapper behavior={FlexBehavior.container} justify={FlexJustify.center}>
        <Spinner color={COLORS.seaBlue} size={50} />
      </StyledCenteredSpinnerWrapper>
    );
  } else if (error) {
    return <ContactUsError />;
  }

  return (
    <>
      <StyledColoredLine linearColor1={linear1} linearColor2={linear2} linearColor3={linear3} />
      <LessonsContainer width={946}>
        <LessonsHeaderContainer
          navLinks={lessonsNavLinks.filter(link => pathname.match(link.regExp))}
          params={{
            ...params,
            names: backLinkNames,
          }}
        />
        <LessonsSubHeader tabIndex={-1}>Select an Exemplar</LessonsSubHeader>
        <ExemplarsContainer>
          {exemplars.map(({ textTypeName, title, thumbnail, lessonId }) => (
            <Related
              textType={textTypeName}
              title={title}
              imgSrc={thumbnail}
              viewLink={`lessons/${lessonId}`}
              key={uuid()}
            />
          ))}
        </ExemplarsContainer>
      </LessonsContainer>
    </>
  );
};
